// This file is automatically generated. Do not edit manually.

import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SirmetShopOrderBatchApi {
	export async function downloadMachineToolCsv(args: {
		shopOrderBatchIds: Array<number>;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/sirmet/shopOrderBatch/downloadMachineToolCsv",
			method: "POST",
			data: {
				shopOrderBatchIds: args.shopOrderBatchIds,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function downloadDftFiles(args: { shopOrderBatchId: number }): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/sirmet/shopOrderBatch/downloadDftFiles",
			method: "POST",
			data: {
				shopOrderBatchId: args.shopOrderBatchId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function downloadDxfFiles(args: { shopOrderBatchId: number }): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/sirmet/shopOrderBatch/downloadDxfFiles",
			method: "POST",
			data: {
				shopOrderBatchId: args.shopOrderBatchId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}
}
